import{ React,useState,useEffect} from 'react'
import api from '../../../api/api';

const EditUser = ({user}) => {
const [userData, setUserData] = useState({})
  useEffect(() => {
        api.get(`/users/?id=${user}`)
        .then(res=> {
          setUserData(res.data[0])

        }).catch(err=> {
          console.log(err)
        })
      }, [user])

  return (
    <div
    className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    id="exampleModalEdit"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    role="dialog"
  >
    <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
      <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
        <div className="flex justify-end">
          <svg
            data-bs-dismiss="modal"
            aria-label="Close"
            className="text-primary-blue h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
            />
          </svg>
        </div>
        <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
        
       
      <div className=" w-full">
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
          View User
        </h1>
       
        <div className="mt-5 p-1 md:!px-1">
          <div className="grid md:grid-cols-2 border-2 border-primary-blue">
            <div className="border-primary-blue flex items-center gap-2 md:border-r border-b p-2">
              <label htmlFor="" className="text-primary-red">
                First Name
              </label>
              <input
                type="text"
                value={userData?.profile?.f_name ?? "null"}
                className=" py-2 px-1 md:w-[150px] text-primary-blue  outline-none"
           
                placeholder="First Name"
              />
            </div>
            <div className="border-primary-blue flex items-center border-b gap-2  p-2">
              <label htmlFor="" className="text-primary-red">
                Last Name
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 md:w-[150px] text-primary-blue px-2 outline-none"
                value={userData?.profile?.l_name ?? "null"}
              
                placeholder="Last Name"
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-b md:border-r border-t-0 p-2 ">
              <label htmlFor="" className="text-primary-red">
                Address:
              </label>
              <input
                type="text"
                name=""
                value={userData?.profile?.address ?? "null"}
                className="flex-grow py-2 text-primary-blue px-2 outline-none"
                placeholder="Address"
                // {...register(`address`, {
                //   // required: false,
                // },setValue("address",userData?.profile?.address ?? "null"))}
              />
            </div>
            <div className="border-primary-blue flex items-center border-b gap-2 p-2">
              <label htmlFor="" className="text-primary-red">
                Email:
              </label>
              <input
                type="email"
                name=""
                value={userData?.email}
                className="flex-grow py-2 px-2 text-primary-blue outline-none"
                placeholder="Email"
                // {...register(`email`, {
                //   // required: false,
                // })}
              />
            </div>
            <div className="border-primary-blue flex flex-wrap items-center border-b md:border-r gap-2  p-2">
              <label htmlFor="" className="text-primary-red">
                Mobile Number:
              </label>
              <input
                type="number"
                value={userData?.phone ?? "null"}
              
                className="flex-grow py-2 px-2 text-primary-blue outline-none"
                placeholder="Phone Number"
              />
            </div>
            <div className="border-primary-blue flex items-center border-b gap-2  p-2">
              <label htmlFor="" className="text-primary-red">
                PAN No
              </label>
              <input
                type="text"
                value={userData?.profile?.pan_number ?? "null"}
             
                className="flex-grow py-2 px-2 text-primary-blue outline-none"
                placeholder="{111111111}"
              />
            </div>

            <div className="border-primary-blue flex items-center gap-2  p-2">
              <label htmlFor="" className="text-primary-red">
                Citizenship
              </label>
              <input
                type="text"
                value={userData?.profile?.citizen_number ?? "null"}
             
                className="flex-grow py-2 text-primary-blue px-2 outline-none"
                placeholder="{111111111}"
              />
            </div>

            {/* <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
            <label htmlFor="" className="text-primary-red">
              Login Type:
            </label>
            <div className="flex flex-wrap items-center gap-2">
              <div className="border-primary-blue flex-shrink-0 rounded-full border px-2 py-1">
                <label className="text-primary-red" htmlFor="">
                  Email
                </label>
                <input type="radio" name="user-id" id="" 
                
                />
                <label className="text-primary-red" htmlFor="">
                  Number:
                </label>
                <input type="radio" name="user-id" id="" />
              </div>
              <input
                type="text"
                className="outline-none"
                placeholder="user id"
                name=""
                id=""
              />
            </div>
          </div> */}
         
          </div>
        </div>
      </div>
   
   
          
        </div>
        
      </div>
    </div>
  </div>
  )
}

export default EditUser